import { tt } from './i18n';

// Story 081 — "started X ago" tooltip for the In Progress match badge.
// Resolution: less than a minute → "just now"; under an hour →
// minutes; an hour or more → hours. Coarser than the bell-time helper
// because the tooltip is glanceable, not exact.

export function formatStartedAgo(
  startedAtIso: string,
  now: Date = new Date(),
): string {
  const startedAt = new Date(startedAtIso);
  const seconds = Math.floor((now.getTime() - startedAt.getTime()) / 1000);
  if (seconds < 60) {
    return tt('common.relative_time.started_just_now');
  }
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) {
    return tt('common.relative_time.started_minutes_ago', { count: minutes });
  }
  const hours = Math.floor(minutes / 60);
  return tt('common.relative_time.started_hours_ago', { count: hours });
}
